import { Component } from "react";
import { Box, Button, Container, Typography } from "@mui/material";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("App error:", error, errorInfo);
    }

    handleReset = () => {
        localStorage.removeItem("userK2G");
        localStorage.removeItem("groupLL");
        this.setState({ hasError: false });
        window.location.href = "/";
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container>
                    <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" sx={{ height: "100vh", textAlign: "center" }}>
                        <Typography variant="h5" color="secondary" fontWeight={600} mb={2}>
                            Something went wrong
                        </Typography>
                        <Typography variant="body1" color="text.secondary" mb={3}>
                            An unexpected error occurred. Please try again.
                        </Typography>
                        <Button variant="contained" color="secondary" onClick={this.handleReset}>
                            Return to Login
                        </Button>
                    </Box>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
